/**
 * @generated SignedSource<<69d01cfc36f355ca85a544aa62be7972>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
import { FragmentRefs } from "relay-runtime";
export type MeetingsPanel_viewer$data = {
  readonly calendarServiceToReconnect: string | null;
  readonly calendars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly color: string | null;
        readonly hadErrorOnSync: boolean | null;
        readonly id: string;
        readonly lastSyncDatetime: string | null;
        readonly name: string | null;
        readonly source: CalendarSource;
        readonly sourcePrimary: boolean;
        readonly syncEnabled: boolean;
      };
    }>;
  };
  readonly dismissedElements: ReadonlyArray<{
    readonly id: string;
    readonly key: string;
  }>;
  readonly hasAccessToCopilot: boolean;
  readonly uxSimplificationEnabled: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"EventFormModal_viewer" | "MeetingsPanelHeader_viewer">;
  readonly " $fragmentType": "MeetingsPanel_viewer";
};
export type MeetingsPanel_viewer$key = {
  readonly " $data"?: MeetingsPanel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingsPanel_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingsPanel_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxSimplificationEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "calendarServiceToReconnect",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DismissedElement",
      "kind": "LinkedField",
      "name": "dismissedElements",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarConnection",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourcePrimary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "syncEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "color",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastSyncDatetime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hadErrorOnSync",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventFormModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingsPanelHeader_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "80e7980bcef330ca114417591b15ae23";

export default node;
